import { Button } from "@/shared/components/ui/button";
import SpecificationTemplateCard from "../../specification/templates/list/specification-templates/components/specification-template-card";
import { useTranslation } from "react-i18next";
import { useSelector } from "@/core/redux/store";
import { inviteService } from "@/shared/services/api/invite";
import { useNavigate } from "react-router-dom";
import { getDashboardLink } from "@/shared/utils/link";
import { ROUTES } from "@/core/router/routes";

export default function InviteSpecificationInbox() {
  const { t } = useTranslation();
  const selectedInbox = useSelector((state) => state.inbox.selectedInbox);
  const navigate = useNavigate();

  if (!selectedInbox) return;

  const template = {
    id: selectedInbox.id,
    createdAt: selectedInbox.createdAt,
    specificationId: selectedInbox.metadata.specification.id,
    description: "",
    tags: [
      "SD-WAN",
      "Network Management",
      "Security Features",
      "Optimization",
      "Central Management",
      "WAN Optimization",
      "VPN",
    ],
    specification: {
      name: selectedInbox.metadata.specification.name,
      tooltip: "",
      shareLinkId: null,
    },
  };

  const acceptInvite = async () => {
    if (
      selectedInbox?.metadata?.hash &&
      !selectedInbox?.metadata?.specification?.id
    )
      return;

    const response = await inviteService.acceptInvite(
      selectedInbox.metadata.hash
    );
    if (response.success) {
      navigate(
        getDashboardLink(ROUTES.Dashboard.Specification.Create) +
          `?specificationId=${selectedInbox.metadata.specification.id}`
      );
    }
  };
  return (
    <>
      <SpecificationTemplateCard
        template={template as any}
        width="100%"
        usedInbox={true}
        itemCount={selectedInbox?.metadata?.itemCount || 0}
      />
      <div className="flex gap-2 mt-4">
        <Button variant="outline" className="w-full">
          {t("decline")}
        </Button>
        <Button variant="default" className="w-full" onClick={acceptInvite}>
          {t("accept")}
        </Button>
      </div>
    </>
  );
}
